//#region imports
import React from 'react';
import { Row, Col } from 'react-bootstrap';
//#endregion

// PRM Assist palette
const NAVY = '#1B4F8A';
const BLUE = '#2E86C1';
const GREEN = '#2E7D32';
const ROW_VLT = '#EAF4FB';

const euro = (n) => `€${Number(n || 0).toLocaleString('en-IE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const num = (n) => Number(n || 0).toLocaleString('en-IE');

// single Paid / Collection / Total card
const StatCard = ({ title, accent, bucket }) => (
    <Col xs={12} md={4} className="mb-2">
        <div style={{ border: '1px solid #e3e3e3', borderTop: `4px solid ${accent}`, borderRadius: 8, padding: '14px 16px', background: '#fff', height: '100%' }}>
            <div style={{ color: accent, fontWeight: 700, fontSize: 15, marginBottom: 10 }}>{title}</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
                <span style={{ color: '#666' }}>Orders</span><span style={{ fontWeight: 600 }}>{num(bucket?.transactions)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
                <span style={{ color: '#666' }}>Lanyards</span><span style={{ fontWeight: 600 }}>{num(bucket?.quantity)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                <span style={{ color: '#666' }}>Revenue</span><span style={{ fontWeight: 700, color: GREEN }}>{euro(bucket?.revenue)}</span>
            </div>
        </div>
    </Col>
);

const thCell = { padding: '8px 10px', textAlign: 'left', fontWeight: 600 };
const tdCell = { padding: '7px 10px', borderBottom: '1px solid #eee' };

// Paid vs Collection-at-Airport summary panel for the Sunflower Lanyard report
const SunflowerReportSummary = ({ summary, byAirport = [] }) => {
    if (!summary) return null;

    return (
        <div style={{ marginTop: 20 }}>
            <Row>
                <StatCard title="Paid" accent={BLUE} bucket={summary.paid} />
                <StatCard title="Collection at Airport" accent={NAVY} bucket={summary.collection} />
                <StatCard title="Total" accent={GREEN} bucket={summary.total} />
            </Row>

            {byAirport.length > 1 && (
                <div style={{ marginTop: 8, overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: NAVY, color: '#fff' }}>
                                <th style={thCell}>Airport</th>
                                <th style={thCell}>Paid (orders / lanyards / €)</th>
                                <th style={thCell}>Collection (orders / lanyards / €)</th>
                                <th style={thCell}>Total (orders / lanyards / €)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {byAirport.map((a, i) => (
                                <tr key={a.airport} style={{ background: i % 2 === 0 ? ROW_VLT : '#fff' }}>
                                    <td style={tdCell}><b>{a.airport}</b></td>
                                    <td style={tdCell}>{num(a.paid?.transactions)} / {num(a.paid?.quantity)} / {euro(a.paid?.revenue)}</td>
                                    <td style={tdCell}>{num(a.collection?.transactions)} / {num(a.collection?.quantity)} / {euro(a.collection?.revenue)}</td>
                                    <td style={tdCell}>{num(a.total?.transactions)} / {num(a.total?.quantity)} / {euro(a.total?.revenue)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default SunflowerReportSummary;
